import { render, staticRenderFns } from "./kategObmen.vue?vue&type=template&id=2b78523c&scoped=true&"
import script from "./kategObmen.vue?vue&type=script&lang=js&"
export * from "./kategObmen.vue?vue&type=script&lang=js&"
import style0 from "./kategObmen.vue?vue&type=style&index=0&id=2b78523c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b78523c",
  null
  
)

export default component.exports